import React from 'react';
import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { statusTypeAPI } from '../redux/status-type.slice';

export function useStatusType(id?: string | null) {
  const { entity: statusType } = useEntityIdSelector(statusTypeAPI, id);
  return React.useMemo(() => ({ statusType }), [statusType]);
}
